import { useIsMobile } from '../hooks/use-mobile';
import { LendoFooterDesktop } from './LendoFooterDesktop';
import { LendoFooterMobile } from './LendoFooterMobile';
import './LendoFooter.css';

export function LendoFooter() {
  const isMobile = useIsMobile();

  return (
    <div className="site-footer-wrapper">
      <footer className="footer z-30">
        {isMobile ? <LendoFooterMobile /> : <LendoFooterDesktop />}
      </footer>
    </div>
  );
}
